import { ErrorOutlined } from '@mui/icons-material';
import { Stack, Tooltip, Typography } from '@mui/material';

import type { SvgIconComponent } from '@mui/icons-material';
import type { SxProps, Theme } from '@mui/material/styles';

export type Props = {
    body?: React.ReactNode;
    header?: React.ReactNode;
    icon?: SvgIconComponent;
    tag: string;
    tagSx?: SxProps<Theme>;
};

const UpdateTag = ({ body, header, icon: Icon = ErrorOutlined, tag, tagSx }: Props) => {
    if (!!body || !!header) {
        return (
            <Tooltip
                data-testid="tooltip"
                placement="right"
                title={
                    <Stack rowGap={2.5}>
                        <Stack
                            direction="row"
                            columnGap={1}
                            alignItems="center"
                            justifyContent="center"
                            sx={{
                                backgroundColor: 'info.main',
                                borderRadius: '4px',
                                maxWidth: 'fit-content',
                                px: '0.5rem',
                                height: '1.75rem',
                            }}
                        >
                            <Icon sx={{ fontSize: '16px', color: 'white' }} />
                            <Typography variant="overline" color="white" mb={0.25}>
                                {tag}
                            </Typography>
                        </Stack>
                        {typeof header === 'string' ? <Typography variant="h3">{header}</Typography> : header}
                        {typeof body === 'string' ? <Typography variant="body2">{body}</Typography> : body}
                    </Stack>
                }
                PopperProps={{
                    sx: {
                        '.MuiTooltip-tooltip': {
                            backgroundColor: 'other.lightMint',
                            padding: 4,
                        },
                        '.MuiTooltip-arrow:before': {
                            backgroundColor: 'other.lightMint',
                        },
                    },
                }}
            >
                <Stack
                    direction="row"
                    columnGap={1}
                    alignItems="center"
                    justifyContent="center"
                    sx={{
                        backgroundColor: 'info.main',
                        borderRadius: '4px',
                        height: '2.25rem',
                        minWidth: 'fit-content',
                        px: '0.75rem',
                        cursor: 'pointer',
                        zIndex: 1000,
                        ...tagSx,
                    }}
                >
                    <Icon sx={{ color: 'white', fontSize: '16px' }} />
                    <Typography variant="body2" color="white" mb={0.125}>
                        {tag}
                    </Typography>
                </Stack>
            </Tooltip>
        );
    }

    return (
        <Stack
            direction="row"
            columnGap={1}
            alignItems="center"
            justifyContent="center"
            sx={{
                backgroundColor: 'info.main',
                borderRadius: '4px',
                height: '2.25rem',
                minWidth: 'fit-content',
                px: '0.75rem',
                zIndex: 1000,
                ...tagSx,
            }}
        >
            <Icon sx={{ color: 'white', fontSize: '16px' }} />
            <Typography variant="body2" color="white" mb={0.125}>
                {tag}
            </Typography>
        </Stack>
    );
};

export default UpdateTag;
